<inline-skjema>
  <form class="e2e-saksskjema" [formGroup]="skjema" (ngSubmit)="lagre()" navigasjonforhindret-flash>
    @if(erAvholdt()){
      <div class="avholdt-møte">
        {{"Du redigerer innholdet i et møte som er avholdt. Vil du fortsette?"|translate}}
      </div>
    }

    <div class="skjemainnhold">
      <fieldset class="tittel-rad">
        <mat-form-field class="tittel">
          <input matInput formControlName="tittel" class="e2e-tittel">
          @if (skjema.controls.tittel.hasError('maxlength')) {
            <mat-error data-testid="maxlength">{{skjema.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>
        @if(erFlerdagsmoete()){
          <mat-form-field class="dag">
            <mat-label>{{ "Dag"|translate }}</mat-label>
            <velg-dag-fra-flerdagsmoete [skjemakontroll]="skjema.controls.dag" [moetedato]="pause().moete.dato"/>
          </mat-form-field>

          @if(visStartklokkeslettvelger){
            <mat-form-field class="startklokkeslett">
              <mat-label>{{ "Starttidspunkt dag {dag}"|translate: {dag: skjema.controls.dag.value!+1} }}</mat-label>
              <klokkeslett-velger formControlName="startklokkeslett"/>
              <mat-icon matPrefix fontSet="ion-ios-clock-outline" class="mat-icon--ionic-ikon"></mat-icon>
            </mat-form-field>
          }
        }

        <mat-form-field>
          <mat-label>{{ "Varighet"|translate }}</mat-label>
          <varighet-minutter-velger [skjemakontroll]="skjema.controls.varighet" [starttidspunkt]="starttidspunkt!" class="e2e-varighet"/>
          <mat-icon matPrefix fontSet="ion-ios-stopwatch-outline" class="mat-icon--ionic-ikon"></mat-icon>
        </mat-form-field>
      </fieldset>

      <mat-form-field class="beskrivelse">
        <mat-label>{{ "Beskrivelse"|translate }}</mat-label>
        <riktekst-redigering [skjemakontroll]="skjema.controls.beskrivelse" [gruppeId]="pause().eiendeGruppeId" innholdBrukesIPdf="true" class="e2e-beskrivelse"/>
      </mat-form-field>

    </div>

    <inline-skjema-handlinger navigasjonforhindret-flash>
      <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()" [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}">
        {{ "Lagre"|translate }}
      </button>
      <button mat-stroked-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    </inline-skjema-handlinger>

  </form>
</inline-skjema>
